import React, { useState, useEffect } from "react";

import { Collapse, Label, Table } from "reactstrap";

//Common
import { FORMA_RATEIO, TIPO_RATEIO } from "@/common/constantes";
import { fn_formatarNumero } from "@/common/utils/util";
import { fn_getLabelCentroCusto, fn_getTipoCentroCusto } from "@/common/siig";

//@codigosEmpresa: código de cada empresa, pelo id ({ [id_empresa]: codigo }), para a coluna Empresa
function TRateio_det_aba_valor({
  tipo_rateio,
  forma_rateio,
  rateios,
  codigosEmpresa = {},
}) {
  const valorTotal = rateios.reduce((acc, cur) => acc + Number(cur.valor), 0);

  //### USE STATE ###
  const [openContas, setOpenContas] = useState([]);

  const [contas, setContas] = useState([]);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Agrupa o rateio por conta
    function agruparRateio() {
      const grupos = rateios.reduce((acc, item) => {
        const idConta = item.conta.id;
        if (!acc[idConta]) {
          acc[idConta] = {
            conta: item.conta,
            itens: [],
            total: 0,
          };
        }

        acc[idConta].itens.push(item);
        acc[idConta].total += Number(item.valor || 0);
        return acc;
      }, {});

      const contas = Object.values(grupos);
      contas.sort((a, b) => a.conta?.nome.localeCompare(b.conta?.nome));
      setContas(contas);

      if (contas.length == 1) {
        setOpenContas([contas[0].conta.id]);
      }
    }

    agruparRateio();
  }, []);

  //### FUNÇÕES ###
  //Alterna a conta aberta
  function toggleConta(idConta) {
    setOpenContas(
      (prev) =>
        prev.includes(idConta)
          ? prev.filter((id) => id !== idConta) // se já está aberta → fecha
          : [...prev, idConta], // senão → abre
    );
  }

  return (
    <div className="m-1">
      <div className="mt-2 mb-2 d-flex align-items-center justify-content-end">
        <Label className="fw-bold mb-0 me-2">Valor total (R$):</Label>
        {fn_formatarNumero(valorTotal, 2)}
      </div>

      <div>
        {contas.map((grupo, index) => {
          const isOpen = openContas.includes(grupo.conta.id);

          return (
            <div key={index} className="mb-2 border rounded-2">
              <div
                className="d-flex justify-content-between align-items-center p-2 bg-light cursor-pointer"
                onClick={() => toggleConta(grupo.conta.id)}
              >
                <div className="fw-bold">{grupo.conta.nome}</div>

                <div className="d-flex align-items-center">
                  <span className="fw-bold me-2">
                    {fn_formatarNumero(grupo.total, 2)}
                  </span>
                  <span
                    style={{
                      transition: "transform 0.3s",
                      transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
                    }}
                    title={isOpen ? "Fechar detalhe" : "Abrir detalhe"}
                  >
                    ▶
                  </span>
                </div>
              </div>

              <Collapse isOpen={isOpen}>
                <div className="p-2">
                  <Table responsive className="mb-0">
                    <thead>
                      <tr>
                        <td className="table-header">Centro de Custo</td>

                        <td width="12%" align="center" className="table-header">
                          Empresa
                        </td>

                        <td width="12%" align="center" className="table-header">
                          Tipo
                        </td>

                        {(tipo_rateio == TIPO_RATEIO.AUTOMATICO ||
                          forma_rateio == FORMA_RATEIO.QUANTIDADE) && (
                          <td align="right" className="table-header">
                            {forma_rateio == FORMA_RATEIO.VALOR
                              ? "Faturamento (R$)"
                              : "Qtde"}
                          </td>
                        )}

                        {tipo_rateio == TIPO_RATEIO.MANUAL &&
                          forma_rateio == FORMA_RATEIO.VALOR && (
                            <td align="right" className="table-header">
                              Percentual (%)
                            </td>
                          )}

                        <td width="18%" align="right" className="table-header">
                          Valor (R$)
                        </td>
                      </tr>
                    </thead>

                    <tbody>
                      {grupo.itens
                        .sort((a, b) =>
                          a.centro_custo.nome.localeCompare(
                            b.centro_custo.nome,
                          ),
                        )
                        .map((rateio, i) => (
                          <tr key={i}>
                            <td>
                              {fn_getLabelCentroCusto(rateio.centro_custo)}
                            </td>

                            <td align="center">
                              {codigosEmpresa[rateio.centro_custo.id_empresa] ??
                                ""}
                            </td>

                            <td align="center">
                              {
                                fn_getTipoCentroCusto(rateio.centro_custo.tipo)
                                  ?.abreviatura
                              }
                            </td>

                            {(tipo_rateio == TIPO_RATEIO.AUTOMATICO ||
                              forma_rateio == FORMA_RATEIO.QUANTIDADE) && (
                              <td align="right">
                                {fn_formatarNumero(
                                  rateio.quantidade,
                                  forma_rateio == FORMA_RATEIO.VALOR ? 2 : 0,
                                )}
                              </td>
                            )}

                            {tipo_rateio == TIPO_RATEIO.MANUAL &&
                              forma_rateio == FORMA_RATEIO.VALOR && (
                                <td align="right">
                                  {fn_formatarNumero(
                                    (Number(rateio.valor) /
                                      Number(grupo.total)) *
                                      100,
                                    4,
                                  )}
                                </td>
                              )}

                            <td align="right">
                              {fn_formatarNumero(rateio.valor, 2)}
                            </td>
                          </tr>
                        ))}
                    </tbody>

                    {grupo.itens.length > 1 && (
                      <tfoot>
                        <tr>
                          <td colSpan="5" className="text-end fw-bold">
                            Qtde. centros: {grupo.itens.length}
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </Table>
                </div>
              </Collapse>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TRateio_det_aba_valor;
